<template>
  <div
    v-if="visible"
    class="w-full border-b border-amber-500/30 bg-amber-500/10 px-4 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
  >
    <p class="text-sm text-amber-100">
      Verify your email to unlock creator actions. Check your inbox for the verification link.
    </p>
    <button
      type="button"
      class="shrink-0 px-3 py-1.5 rounded-lg bg-amber-400 text-black text-sm font-semibold hover:bg-amber-300 transition-colors disabled:opacity-60"
      :disabled="isResending"
      @click="handleResend"
    >
      {{ isResending ? 'Sending...' : 'Resend verification' }}
    </button>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStorage } from '@/composables/use-storage';
import { useToast } from '@/composables/use-toast';
import { resendVerificationEmail } from '@/services/authService.js';
import { getFriendlyErrorMessage, RESEND_VERIFICATION_THROTTLE_TOAST } from '@/utils/errorUtils.js';

const { userInfo, isLoggedIn } = useStorage();
const { addToast } = useToast();

const isResending = ref(false);

const visible = computed(() => {
  if (!isLoggedIn()) {
    return false;
  }
  const info = userInfo?.value;
  if (!info?.id) {
    return false;
  }
  return info.email_verified === false;
});

const handleResend = async () => {
  isResending.value = true;
  try {
    const response = await resendVerificationEmail();
    addToast(response?.message || 'Verification email sent', 'success');
  } catch (error) {
    addToast(
      error.response?.status === 429
        ? RESEND_VERIFICATION_THROTTLE_TOAST
        : getFriendlyErrorMessage(error, 'Unable to resend verification email'),
      'error',
    );
  } finally {
    isResending.value = false;
  }
};
</script>
